import { useState } from "react";

export default function ShareModal({ title, onClose }: { title: string; onClose: () => void }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-primary-950/60" onClick={onClose} aria-hidden="true" />
      <div className="relative w-full max-w-sm rounded-lg bg-background-50 p-6 animate-fade-up">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-base font-semibold text-foreground-950">分享作品</h3>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭分享"
            className="w-8 h-8 flex items-center justify-center rounded-md text-foreground-600 text-xl cursor-pointer"
          >
            <i className="ri-close-line" aria-hidden="true"></i>
          </button>
        </div>
        <p className="text-sm text-foreground-600 mb-4">
          分享《<span className="text-foreground-900 font-medium">{title}</span>》给好友（演示功能）
        </p>
        <div className="grid grid-cols-4 gap-3 mb-5">
          {[
            { icon: "ri-wechat-line", label: "微信" },
            { icon: "ri-weibo-line", label: "微博" },
            { icon: "ri-qq-line", label: "QQ" },
            { icon: "ri-share-forward-line", label: "更多" },
          ].map((item) => (
            <button
              key={item.label}
              type="button"
              className="flex flex-col items-center gap-1.5 py-2 rounded-md hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className="w-10 h-10 rounded-full bg-primary-50 text-primary-600 flex items-center justify-center text-xl">
                <i className={item.icon} aria-hidden="true"></i>
              </span>
              <span className="text-xs text-foreground-600">{item.label}</span>
            </button>
          ))}
        </div>
        <button
          type="button"
          onClick={handleCopy}
          className="w-full py-2.5 rounded-md bg-accent-500 text-primary-950 text-sm font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {copied ? "链接已复制" : "复制页面链接"}
        </button>
        <p className="mt-3 text-center text-xs text-foreground-400">分享为演示效果，不产生真实分享行为</p>
      </div>
    </div>
  );
}